import svg from 'shared/assets/wiw-logo-big.svg';

const Logo = () => (
  <div className='logo'>
    <img src={ svg } alt="" />
  </div>
);

export default Logo;
